// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AiComponentSourceSchema = z.enum(['SOURCE_CODE','DISCOVERY','MANUAL','OPERATOR'] as const);

export type AiComponentSourceType = `${z.infer<typeof AiComponentSourceSchema>}`

export default AiComponentSourceSchema;
